<template>
  <el-dialog title="新增可预约日期" :visible.sync="dialogVisible" :before-close="cancel" width="30%">
    <el-form class="g-form-grid" ref="checkForm" label-width="105px" :model="checkForm" :rules="checkRules">
      <el-form-item label="展厅 :" prop="ids">
        <el-select style="width: 100%;" clearable multiple v-model="checkForm.ids" placeholder="请选择">
          <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="日期 :" class="time-select w-100" prop="date">
        <el-date-picker class="w-100" v-model="checkForm.date" value-format="yyyy-MM-dd" placeholder="开始日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="可预约时段 :" prop="times">
        <el-select style="width: 100%;" clearable multiple v-model="checkForm.times" placeholder="请选择">
          <el-option v-for="(item, index) in timePeriod" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="submit" type="primary" :loading="loadingCheck">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      checkForm: {
        ids: '',
        date: '',
        times: ''
      },
      dialogVisible: false,
      loadingCheck: false,
      timePeriod: ['09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30'],
      tableData: [],
      listQuery: {
        currentPage: 1,
        size: 1000
      },
      checkRules: {
        ids: [{ required: true, message: '展览不能为空', trigger: 'blur' }],
        date: [
          { required: true, message: '预约日期不能为空', trigger: 'blur' }
        ],
        times: [{ required: true, message: '时段不能为空', trigger: 'blur' }]
      }
    }
  },

  methods: {
    init() {
      this.dialogVisible = true

      this.initList()
      this.getTime()
    },

    initList() {
      this.tableData = []
      this.$api.volunteer
        .getExhibitionList({
          serviceType: '1',
          ...this.listQuery
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        })
    },

    // getTime() {
    //   this.$api.common
    //     .getSelectDataByKey({ key: 'time_interval' })
    //     .then((res) => {
    //       if (res.success) {
    //         this.timePeriod = res.result
    //       }
    //     })
    // },


    submit() {
      this.$refs['checkForm'].validate((valid) => {
        if (valid) {
          this.loadingCheck = true
          this.$http
            .get('/v2/bsVolunteerV2Exhibition/addTime', {
              ids: this.checkForm.ids.join(','),
              date: this.checkForm.date,
              times: this.checkForm.times.join(','),

            })
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message || '新增成功')
                this.cancel()
              } else {
                this.$message.error(res.message || '新增失败')
              }
              this.loadingCheck = false
            })
            .catch((err) => {
              this.loadingCheck = false
            })
        }
      })
    },

    cancel() {
      this.dialogVisible = false
      this.$refs['checkForm'].resetFields()
      this.tableData = []
    }
  }
}
</script>